angular.module('tf.directives')

    .directive('galleryItem', function () {
        return{
            restrict:'E',
            replace:true,
            scope:{
                item : "=",
                breadcrumbs : '='
            },
            templateUrl:'js/components/galleryItem/galleryItem.html',
            controller:'GalleryItemController',
            link: function(scope,element,attr){
            }
        };
    })
    .controller('GalleryItemController', ['$scope','$state','ShareService','ProjectService','ScheduleService','Session',
        function($scope, $state, ShareService, ProjectService, ScheduleService, Session) {
        $scope.type = $scope.item.type;
        $scope.role = Session.role;
        $scope.item.breadcrumbs = $scope.breadcrumbs;
        switch ($scope.type){
            case 0:
                $scope.state = "app.folder";
                $scope.defaultImage = "'../img/folder3.svg'";
                break;
            case 1:
                $scope.state = "app.project";
                $scope.defaultImage = "'../img/file2.svg'";
                break;
            case 2:
                $scope.defaultImage = "'../img/file2.svg'";
                break;
            default :
                $scope.state = "app.folder";
                $scope.defaultImage = "'../img/farmer.svg'";
                break;
        }
        $scope.stateParams = {path: $scope.item.url};
        $scope.$state = $state;
        $scope.shareService = ShareService;
        $scope.share = function(){
            ShareService.open(this.item);
        };
        $scope.shareOptions = function(){
            ShareService.whoHasAccess(this.item);
        };

        $scope.openProjectSettings = function(path){
            ProjectService.openSettings(path);
        };

        $scope.openScheduler = function(path){
            ScheduleService.openScheduler(path);
        };

        $scope.statProperties = {encoded : $scope.item.url};

    }])

;
